import {
    Button,
    Card,
    Input, Modal,
    PageHeader, Select, Spin,
    Tag,
} from "@arco-design/web-react";
import React, {useEffect, useState} from "react";
import ChatDialogue from "../components/ChatDialogue";
import chatMan from "../assets/logo.png"
import {useNavigate, useParams} from "react-router-dom";
import logo from "../assets/logo.png";
import axios from "axios";
import handleChatGPT from "../services/handleChatGPT";
import handlePersonData from "../services/handlePersonData";


function Chat(){
    const [messages, setMessages] = useState([]);
    const [inputText, setInputText] = useState('');
    const navigate = useNavigate();
    const {id}=useParams()
    const [data,setData] = useState({})
    const [loading,setLoading] = useState(false)

    useEffect(() => {
        const getNewData = async () => {
            const newData = await handlePersonData(id)
            setData(newData)
        }
        getNewData()
    }, [id]);

    const handleInputChange = (data) => {
        setInputText(data);
    };

    const handleSendMessage = async (prompt) => {
        setLoading(true)
        if (inputText.trim() !== '') {
            const ans= await handleChatGPT(prompt, 1,JSON.stringify(data)).then((data)=>{
                setMessages([...messages,{message:inputText,isLeft:false},{message:data,isLeft:true}])
                setInputText('');
                setLoading(false)})
        }
    };

    return (
        <div className="home" style={{overflowX: "hidden"}}>
            <div className="home-left" style={{width:"25%"}}>
                <div className="chat-header"  style={{cursor:'pointer'}} onClick={() => navigate('/carboncopydating')}>
                    <img src={logo} width={36} style={{marginRight: 6,cursor:'pointer'}}/>
                        carbon copy
                </div>
                <div className="chat-info-card">
                    <div className="person-title-3">
                        <img src={data.photo?.url ?? logo} style={{ objectFit: "cover",width:"90%",height:"60%",margin:24,borderRadius:24}}/>
                        <div>
                            NAME: {data.name}
                        </div>
                        <div>
                            AGE: {data.age}
                        </div>
                        <div>
                            GENDER: {data.gender}
                        </div>
                        <div>
                            OCCUPATION: {data.occupation}
                        </div>
                    </div>
                </div>
            </div>
            <div className="home-right" style={{width:"75%",overflow:"hidden"}}>
                <Card bordered={false} className="content-card">
                    <PageHeader
                        style={{background: 'var(--color-bg-2)'}}
                        title={<div>
                            <div className="buttom-grey" style={{padding: "1px 10px", margin: 0}} onClick={() => {
                                navigate(`/carboncopydating/person/${Number(id)}`)
                            }}>BACK
                            </div>
                        </div>}
                    >
                    </PageHeader>
                    <div>
                        <div className="messages" style={{width:"100%"}}>
                            {
                                messages.length===0 ?
                                    <div>
                                    </div> :
                                    messages.map((message, index) => (
                                        <ChatDialogue
                                            key={index}
                                            message={message.message}
                                            isLeft={message.isLeft}
                                            avatar={message.isLeft ? data.photo?.url : chatMan}
                                        />
                                    ))

                            }
                        </div>
                        <div className="chat-button" style={{alignItems:"center"}}>
                            <Input.TextArea
                                autoSize={{minRows: 2, maxRows: 2}}
                                className="chat-input"
                                value={inputText}
                                placeholder="Type your message..."
                                onChange={handleInputChange}
                            />
                            <Spin loading={loading}>
                                <div className="buttom-pink" style={{margin: 0,  marginLeft: 12}}
                                     onClick={() => {
                                         handleSendMessage(inputText)
                                     }}>
                                    Send
                                </div>
                            </Spin>
                        </div>
                    </div>
                </Card>
            </div>
        </div>
    );
}
export default Chat
